module.exports = __webpack_public_path__ + "static/media/new-lock.7ac2ee50.svg";